import React, { useState } from "react";
import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

/**
 * FachInfo — App-weiter Standard für dezente fachliche Erläuterungen (Steuer/Recht).
 *
 * Verwendung:
 *   <Label>Privatanteil <FachInfo title="Privatanteil" law="§ 12 UStG (AT)">Erklärtext…</FachInfo></Label>
 *
 * Verhalten: Info-Icon (dezent grau), Tooltip bei Hover/Fokus, Klick toggelt (Touch-Geräte).
 * Siehe /app/memory/STYLEGUIDE_FACHINFO.md
 */
export const FachInfo = ({ title, law, children, side = "top", className = "", testId = "fach-info" }) => {
  const [open, setOpen] = useState(false);
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid={testId}
            aria-label={title ? `Info: ${title}` : "Fachliche Erläuterung"}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
            className={`inline-flex items-center align-middle -mt-0.5 ml-0.5 text-slate-400 hover:text-slate-600 focus:outline-none focus:text-slate-600 transition-colors ${className}`}
          >
            <Info className="h-3.5 w-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs" data-testid={`${testId}-content`}>
          {title && <div className="text-xs font-semibold mb-1">{title}</div>}
          <div className="text-[11px] leading-relaxed font-normal">{children}</div>
          {law && <div className="text-[10px] mt-1.5 opacity-70 font-medium">{law}</div>}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default FachInfo;
